/* Ezzyrol homepage v2: hero scenes (sections/ez-hero-scenes.liquid). Runs on window.EZH (assets/ez-home.js).
   SPEC "2. Hero", prototype /tmp/lp2/final/app.js.

   The red fill on the active index item is a CSS animation and its animationend IS the timer, so the mover's
   .is-paused class freezes the fill, the Ken Burns zoom and the timer together, exactly.
   A resting or hovering mouse never stops it. It stops for: the pause pill (and EZH.pauseAll), keyboard focus inside,
   less than 12% on screen, a hidden tab, waiting (up to 1.5 s) for the next photo (a click, tap or swipe to a scene
   whose photo has not loaded waits too, so the words never change over the wrong photo), scene 1's own photo still
   loading (at most 8 s), and the theme editor's block select.
   Going back to the scene that has just left (it still sits under the new one) fades the current photo out on top,
   so nothing cuts in one frame and the zoom never snaps back.
   Reduced motion: still changes, every 8 s with a .5 s fade (no zoom, no text slide: ez-h-hero.css). */
(function () {
  'use strict';
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  function setup(root) {
    var EZH = window.EZH;
    if (!root || root.__ezhhHero || !EZH) return;
    var slides = $$('.ezhh-slide', root), texts = $$('.ezhh-text', root), idx = $$('.ezhh-i', root);
    var n = slides.length;
    if (!n) return;
    var stage = $('.ezhh-stage', root);
    var pill = $('.ezhh-pause', root);
    var baseInt = parseInt(root.getAttribute('data-interval'), 10) || 3500;
    var baseFade = parseInt(root.getAttribute('data-fade'), 10) || 900;
    var cur = 0, pending = -1, rz = 0;
    var api = { go: go, get index() { return cur; } };
    root.__ezhhHero = api;

    function timing() {
      var r = EZH.reduced;
      root.style.setProperty('--int', (r ? 8000 : baseInt) + 'ms');
      root.style.setProperty('--fade', (r ? 500 : baseFade) + 'ms');
    }
    timing();
    var unRed = EZH.onReduced(timing);

    var m = api.mover = EZH.mover(root, {
      reduced: 'run', threshold: 0.12, pauseButton: pill || false,
      onChange: function (running) { if (running && pending > -1) { var k = pending; pending = -1; go(k, 'timer'); } }
    });

    function warm(k) {
      var s = slides[((k % n) + n) % n];
      $$('img', s).forEach(EZH.warm);
    }
    function ready(k) {
      var im = $('img', slides[k]);
      return !im || (im.complete && im.naturalWidth > 0);
    }
    // scene 1 is the LCP: its fill (the timer) starts once its own photo has loaded, at most 8 s, so on a slow phone the
    // slideshow never moves on before the first photo shows and scene 2's file never takes bandwidth from it
    if (!ready(0)) {
      var first = $('img', slides[0]);
      var firstDone = function () {
        first.removeEventListener('load', firstDone); first.removeEventListener('error', firstDone);
        m.hold('first', false);
      };
      m.hold('first', true);
      first.addEventListener('load', firstDone); first.addEventListener('error', firstDone);
      setTimeout(firstDone, 8000);
    }

    /* ---- pin cards: keep the side the scene prefers at this width; flip it when the card would leave the photo
       (16 px margin) or cover the kicker, the headline, the pills, the rating, the index or the pause pill. Measured
       from layout boxes, not getBoundingClientRect, because the pin is mid-transition when a scene changes. */
    function obstacles(k) {
      var els = innerWidth < 750 ? [pill]
        : [$('.ezhh-h1', root)].concat($$('.ezhh-ln, .ezh-btn', texts[k]), [$('.ezhh-rate', root), $('.ezhh-idx', root), pill]);
      return els.filter(Boolean).map(function (el) { return el.getBoundingClientRect(); }).filter(function (r) { return r.width && r.height; });
    }
    function fitPin(k) {
      var pin = $('.ezhh-pin', slides[k]);
      if (!pin) return;
      var card = $('.ezhh-pin__card', pin), cs = getComputedStyle(pin);
      var dr = parseFloat(cs.getPropertyValue('--dr')) || 11, cg = parseFloat(cs.getPropertyValue('--cg')) || 8;
      var cmt = parseFloat(cs.getPropertyValue('--cmt')) || -11;
      var pl = pin.offsetLeft, pt = pin.offsetTop;
      var sr = stage.getBoundingClientRect(), obs = obstacles(k), cw = card.offsetWidth, ch = card.offsetHeight;
      function score(left) {
        var l = sr.left + (left ? pl - dr - cg - cw : pl + dr + cg), r = l + cw, t = sr.top + pt + cmt, b = t + ch;
        var s = (Math.max(0, sr.left + 16 - l) + Math.max(0, r - (sr.right - 16))) * 1000;
        obs.forEach(function (o) { s += Math.max(0, Math.min(r, o.right) - Math.max(l, o.left)) * Math.max(0, Math.min(b, o.bottom) - Math.max(t, o.top)); });
        return s;
      }
      var pref = (innerWidth < 750 ? pin.getAttribute('data-m') : pin.getAttribute('data-d')) === 'l';
      var a = score(pref), b = a ? score(!pref) : Infinity;
      var left = b < a ? !pref : pref;
      pin.setAttribute('data-side', left ? 'l' : 'r');
      pin.setAttribute('data-fit', JSON.stringify([Math.round(a), b === Infinity ? -1 : Math.round(b)]));
    }

    function setIndex(k) {
      idx.forEach(function (t, j) {
        t.classList.toggle('is-done', j < k);
        if (j === k) { t.setAttribute('aria-current', 'true'); t.classList.remove('is-on'); void t.offsetWidth; t.classList.add('is-on'); }
        else { t.removeAttribute('aria-current'); t.classList.remove('is-on'); }
      });
    }

    /* go(k, how): how is 'timer' (the fill ended), 'user' (index click, story bar, swipe) or 'editor' (block select).
       Every jump waits for the target photo (at most 1.5 s, the index fill paused meanwhile), so the words and the
       photo always change together and never show one scene's headline over another scene's photo. */
    var wait = null;
    function cancelWait() {
      if (!wait) return;
      clearTimeout(wait.t);
      wait.im.removeEventListener('load', wait.f); wait.im.removeEventListener('error', wait.f);
      wait = null;
      m.hold('loading', false);
    }
    function go(k, how) {
      k = ((k % n) + n) % n;
      if (how !== 'timer' && how !== 'editor') how = 'user';
      if (k === cur) { cancelWait(); return; }
      warm(k);
      cancelWait();
      if (how !== 'editor' && !ready(k)) {      // never cut to a blank photo: hold the fill until it has loaded
        var im = $('img', slides[k]);
        var w = wait = { im: im, t: 0, f: null };
        w.f = function () {
          if (wait !== w) return;
          cancelWait();
          if (how === 'user' || m.running) show(k); else pending = k;
        };
        im.addEventListener('load', w.f); im.addEventListener('error', w.f);
        w.t = setTimeout(w.f, 1500);
        m.hold('loading', true);
        return;
      }
      show(k);
    }

    function show(k) {
      pending = -1;
      var ps = slides[cur], ns = slides[k], pt = texts[cur], nt = texts[k];
      var fade = parseFloat(getComputedStyle(root).getPropertyValue('--fade')) || baseFade;
      // where the target photo is now: under the current one at full strength (it has just left), fading out on top
      // (we are going back and forth), or out of sight (the normal case)
      var under = ns.classList.contains('is-off'), over = ns.classList.contains('is-leave');
      // the outgoing words, pills and pin leave first (.2 to .28 s), before the new photo has landed
      // they stay clickable until their pills have faded (.2 s), while the incoming pills take no click until they
      // start to show (.5 s, ez-h-hero.css): a click always lands on the pill the shopper can see
      if (pt) {
        pt.classList.remove('is-on', 'is-first'); pt.classList.add('is-out');
        pt.setAttribute('aria-hidden', 'true');
        clearTimeout(pt.__ezhhT); clearTimeout(pt.__ezhhI);
        if (EZH.reduced) pt.inert = true;
        else pt.__ezhhI = setTimeout(function () { pt.inert = true; }, 200);
        pt.__ezhhT = setTimeout(function () { pt.classList.remove('is-out'); }, 340);
      }
      ps.classList.remove('is-on'); ps.inert = true;
      clearTimeout(ps.__ezhhT);
      if (under) {
        // back to the scene that has just left: it is still fully there underneath, so the current photo fades out
        // on top instead of the old one cutting in, and its zoom carries on (no snap back to scale 1)
        ps.classList.remove('is-off'); ps.classList.add('is-leave');
        ps.__ezhhT = setTimeout(function () { if (!ps.classList.contains('is-on')) ps.classList.remove('is-leave'); }, fade + 120);
      } else {
        // the outgoing photo stays at full strength underneath while the new one fades in above it (no dip); if the
        // new photo is still loading (the 1.5 s wait ran out), the old one stays until it has arrived
        ps.classList.remove('is-leave'); ps.classList.add('is-off');
        var drop = function () { if (!ps.classList.contains('is-on')) ps.classList.remove('is-off'); };
        var nim = $('img', ns);
        if (nim && !(nim.complete && nim.naturalWidth > 0)) {
          var late = function () { nim.removeEventListener('load', late); nim.removeEventListener('error', late); ps.__ezhhT = setTimeout(drop, fade + 100); };
          nim.addEventListener('load', late); nim.addEventListener('error', late);
        } else {
          ps.__ezhhT = setTimeout(drop, 1400);
        }
      }
      var po = $('.ezhh-pin', ps); if (po) po.tabIndex = -1;
      var img = $('img', ns);
      // restart the zoom only on a photo that is out of sight; one that shows (under, or fading on top) keeps going
      if (img && !under && !over) { img.style.animation = 'none'; void img.offsetWidth; img.style.animation = ''; }
      clearTimeout(ns.__ezhhT);
      ns.classList.remove('is-off', 'is-leave'); ns.classList.add('is-on'); ns.inert = false;
      var pn = $('.ezhh-pin', ns); if (pn) pn.removeAttribute('tabindex');
      if (nt) {
        clearTimeout(nt.__ezhhT); clearTimeout(nt.__ezhhI);
        nt.classList.remove('is-out'); nt.inert = false; nt.removeAttribute('aria-hidden');
        void nt.offsetWidth; nt.classList.add('is-on');
      }
      cur = k;
      fitPin(k);
      setIndex(k);
      warm(k + 1);
    }

    root.addEventListener('animationend', function (e) {
      if (e.animationName === 'ezhh-fill' && e.target.closest('.ezhh-i.is-on')) go(cur + 1, 'timer');
    });
    idx.forEach(function (t, j) { t.addEventListener('click', function () { go(j, 'user'); }); });   // jump, carry on

    var sx = null, sy = 0;
    stage.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (sx == null) return;
      var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) go(cur + (dx < 0 ? 1 : -1), 'user');
      sx = null;
    }, { passive: true });

    function onResize() { clearTimeout(rz); rz = setTimeout(function () { fitPin(cur); }, 120); }
    addEventListener('resize', onResize);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { fitPin(cur); });
    // the display face is added after the first photo (snippets/ez-home-assets): fit again once it has swapped in
    if (document.fonts && document.fonts.addEventListener) document.fonts.addEventListener('loadingdone', function () { fitPin(cur); });
    fitPin(cur);
    root.classList.add('is-fitted');      // pins show once their side is settled: no load shift

    // scene 2 loads 300 ms after the page has loaded; each later scene loads while the one before it shows
    function warmNext() { setTimeout(function () { warm(cur + 1); }, 300); }
    if (document.readyState === 'complete') warmNext(); else addEventListener('load', warmNext, { once: true });

    // theme editor: selecting a scene block shows it and holds it there until it is deselected
    function sel(e) { var k = slides.indexOf(e.target.closest ? e.target.closest('.ezhh-slide') : null); if (k > -1) { warm(k); go(k, 'editor'); m.hold('editor', true); } }
    function desel() { m.hold('editor', false); }
    root.addEventListener('shopify:block:select', sel);
    root.addEventListener('shopify:block:deselect', desel);

    api.destroy = function () {
      removeEventListener('resize', onResize);
      unRed();
      m.destroy();
      delete root.__ezhhHero;
    };
  }

  function init(scope) { $$('[data-ez-h-hero]', scope).forEach(setup); }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    $$('[data-ez-h-hero]', e.target).forEach(function (r) { if (r.__ezhhHero && r.__ezhhHero.destroy) r.__ezhhHero.destroy(); });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
})();
